export function fmtUsd(n, { cents = false } = {}) {
  if (n == null || n === '') return '—';
  const num = Number(n);
  if (Number.isNaN(num)) return '—';
  return num.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: cents ? 2 : 0,
    maximumFractionDigits: cents ? 2 : 0,
  });
}

export function fmtUsdRange(min, max, opts) {
  if (min == null || max == null) return '—';
  return `${fmtUsd(min, opts)} – ${fmtUsd(max, opts)}`;
}

// Translate known non-English data labels (stray locale-test rows that landed
// in the bookings / RV-intelligence tables) into their English equivalents so
// unintelligible values never reach the UI. ASCII strings pass through
// untouched; unknown non-ASCII strings fall back to "Unknown" so the row
// still renders cleanly.
const NON_ENGLISH_TO_ENGLISH = {
  // Japanese rows seen in staging + e2e fixtures
  '戻る': 'Back',
  'キャンピングカー': 'Motorhome',
  '助手席側': 'Passenger side',
  'デラックスプレミアムバックイン': 'Deluxe Premium Back-In',
  'デラックスバックイン': 'Deluxe Back-In',
  'RV旅行': 'RV Travel',
  'RVサイト': 'RV Site',
};

export function displayLabel(s, fallback = 'Unknown') {
  if (typeof s !== 'string' || s.length === 0) return fallback;
  if (NON_ENGLISH_TO_ENGLISH[s]) return NON_ENGLISH_TO_ENGLISH[s];
  return /^[\x00-\x7F]+$/.test(s) ? s : fallback;
}

// GeoIP city-states / capital regions repeat the city as the region
// ("Madrid, Madrid", "New York, New York") — drop the duplicate. Optionally
// appends the country (expanding 2-letter codes like "ES" → "Spain") when the
// region was dropped or missing, so the label keeps two parts where possible.
export function fmtLocation(city, region, country = null) {
  const c = (city || '').trim();
  const r = (region || '').trim();
  const parts = [];
  if (c) parts.push(c);
  if (r && r.toLowerCase() !== c.toLowerCase()) parts.push(r);
  else if (country && parts.length === 1) {
    let name = country;
    if (/^[A-Za-z]{2}$/.test(country)) {
      try { name = new Intl.DisplayNames(['en'], { type: 'region' }).of(country.toUpperCase()) || country; } catch { /* keep code */ }
    }
    parts.push(name);
  }
  return parts.join(', ');
}
